import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_OBLIGATION = "[OBLIGATION] GET_OBLIGATION";
export const GET_OBLIGATION_SUCCESS = "[OBLIGATION] GET_OBLIGATION_SUCCESS";
export const GET_OBLIGATION_FAILED = "[OBLIGATION] GET_OBLIGATION_FAILED";

export const RELOAD_OBLIGATION = "[OBLIGATION] RELOAD_OBLIGATION";
export const RELOAD_OBLIGATION_SUCCESS =
	"[OBLIGATION] RELOAD_OBLIGATION_SUCCESS";
export const RELOAD_OBLIGATION_FAILED = "[OBLIGATION] RELOAD_OBLIGATION_FAILED";

export const SET_VALUE = "[OBLIGATION] SET_VALUE";
export const CLEAR_VALUES = "[OBLIGATION] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getObligations(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_OBLIGATION });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/obligation?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_OBLIGATION_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_OBLIGATION_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_OBLIGATION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function reloadTaxes(cnpj, callback) {
	return async (dispatch, getState) => {
		dispatch({ type: RELOAD_OBLIGATION });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/obligation/consult-dasn-cnpj/${cnpj}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: RELOAD_OBLIGATION_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: RELOAD_OBLIGATION_FAILED,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: RELOAD_OBLIGATION_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
